import React, {useState} from "react";
import {Link} from "react-router-dom";
import {SurveyWave,useDismissSurveyMutation,useSurveyStatus} from "../hooks/useSurveyStatus";

export const surveyWaveLabels:Record<SurveyWave,string>={start:"baseline","3m":"3-month","6m":"6-month","12m":"12-month"};

export function SurveyGateBanner() {
  const {status,scope,loading,error,refetch}=useSurveyStatus();
  const [dismiss,{isLoading}]=useDismissSurveyMutation();
  const [failure,setFailure]=useState(false);
  if(loading) {return null;}
  if(error || !status) {return <aside className="mb-5 rounded-xl border p-4" aria-label="Staff AI survey">
    <p>Survey availability couldn't be checked.</p>
    <button type="button" className="underline" onClick={()=>void refetch()}>Try again</button>
  </aside>;}
  const answered=status.waves.find(wave=>wave.responded);
  const waves=status.enabled?status.waves.filter(wave=>wave.bannerVisible):[];
  if(!waves.length && !answered) {return null;}
  return <aside className="mb-5 space-y-3 rounded-xl border border-primary/30 bg-white p-5" aria-label="Staff AI survey">
    <h2 className="text-lg font-semibold">Staff AI survey</h2>
    {answered && <Link className="inline-block text-primary underline" to={"/survey/"+answered.wave}>View my survey responses</Link>}
    {waves.map(({wave,required})=><div key={wave} className="flex flex-wrap items-center gap-4">
      <p>{wave==="start" && !required?"You can take a baseline survey to look back on your progress.":`Your ${surveyWaveLabels[wave]} survey is ready.`}</p>
      <Link className="font-semibold text-primary underline" to={"/survey/"+wave}>Take the {surveyWaveLabels[wave]} survey</Link>
      <button type="button" className="text-sm underline" disabled={isLoading} onClick={async()=>{
        setFailure(false);
        try {await dismiss({scope,wave}).unwrap();} catch {setFailure(true);}
      }}>Dismiss for 7 days</button>
    </div>)}
    {failure && <p role="alert">The banner couldn't be dismissed. Please try again.</p>}
  </aside>;
}
